// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/Portals/index.css
// module id = 1879
// module chunks = 0